'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["mode", "onModeChange", "onEdit", "onTokenRemove"];
import PropTypes from 'prop-types';
import { CSSTransitionGroup as CSSTransition } from 'react-transition-group';
import { KeyTypes, PopoverBodyMode } from '../../constants/popover';
import PersonalizePopoverBodyEdit from './PersonalizePopoverBodyEdit';
import PersonalizePopoverBodyLite from './PersonalizePopoverBodyLite';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  mode: PropTypes.oneOf(Object.values(PopoverBodyMode)),
  onModeChange: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onTokenRemove: PropTypes.func.isRequired
};
function PersonalizePopoverBodyBranch(props) {
  const {
      mode,
      onModeChange,
      onEdit,
      onTokenRemove
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleClose = () => {
    onModeChange(PopoverBodyMode.PREVIEW);
  };
  const handleEdit = () => {
    onModeChange(PopoverBodyMode.EDIT);
  };
  const handleUpdate = (...args) => {
    handleClose();
    onEdit(...args);
  };
  const handleKeyDown = evt => {
    if (evt.key === KeyTypes.ESCAPE) {
      handleClose();
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: "animated-popover-body",
    onKeyDown: handleKeyDown,
    tabIndex: "-1",
    children: /*#__PURE__*/_jsx(CSSTransition, {
      className: "animated-transition",
      transitionName: "animated-popover",
      transitionEnterTimeout: 100,
      transitionLeaveTimeout: 100,
      children: mode === PopoverBodyMode.PREVIEW ? /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(PersonalizePopoverBodyLite, {
          onEdit: handleEdit,
          onRemove: onTokenRemove
        })
      }, "personalize-popover-lite-container") : /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(PersonalizePopoverBodyEdit, Object.assign({}, rest, {
          onInsert: handleUpdate,
          onClose: handleClose
        }))
      }, "personalize-popover-edit-container")
    })
  });
}
PersonalizePopoverBodyBranch.propTypes = propTypes;
PersonalizePopoverBodyBranch.displayName = 'PersonalizePopoverBodyBranch';
export default PersonalizePopoverBodyBranch;